<script setup>
import { onMounted, ref, computed, defineProps, watch } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  courseId: String,
});

const store = useStore();

const selectedRegion = ref("");
const regionsList = computed(() => store.getters["regions/getRegionsList"]);
const messageClass = ref("");
const loading = ref(false);
const isLoadingRegions = computed(() => store.getters["regions/isLoading"]);
const isAddingCourseLoading = computed(() => store.getters["course/isLoading"]);
const message = computed(() => store.getters["course/getMessage"]);
const errors = computed(() => store.getters["course/getErrors"]);

const isLoading = computed(() => {
  return isLoadingRegions.value || isAddingCourseLoading.value;
});

const loadRegions = async () => {
  await store.dispatch("regions/fetchRegions");
};

watch(message, (newValue) => {
  if (newValue.length > 0) {
    messageClass.value = "text-success";
  }
});

watch(errors, (newValue) => {
  if (newValue !== null || newValue !== "") {
    messageClass.value = "text-danger";
  }
});

const addTo4 = async () => {
  if (!selectedRegion.value) {
    store.commit("course/SET_ERRORS", "Please select a region");
    return;
  }

  const payload = {
    courseId: Number(props.courseId),
    region: selectedRegion.value,
  };
  console.log("Payload:", payload);
  store.dispatch("course/migrateCourse", payload);
};

onMounted(() => {
  loadRegions();
  console.log("isAddingCourseLoading:", isAddingCourseLoading.value);
  console.log("isAddingCourseLoading:", isLoadingRegions.value);
});
</script>

<template>
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Add to 4.0</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-10">
            <div class="select2-primary">
              <select class="form-control" v-model="selectedRegion">
                <option disabled value="">Region</option>
                <option
                  v-for="region in regionsList"
                  :key="region.id"
                  :value="region.slug"
                >
                  {{ region.slug }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-2">
            <button
              @click="addTo4"
              class="btn btn-primary"
              style="width: 100%"
              :disabled="loading"
            >
              <span v-if="isLoading">Loading...</span>
              <span v-else>Add to 4.0</span>
            </button>
          </div>
        </div>
        <div v-if="message" :class="messageClass" class="mt-3">
          {{ message }}
        </div>
        <div v-if="errors" :class="messageClass" class="mt-3">
          {{ errors }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mt-3 {
  margin-top: 1rem;
}
</style>
